module.exports = require("./da-DK");